


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import defaultAvatar from '@/assets/images/users/avator-upload-default.png';
import { CellGroup, Swipe, SwipeItem } from 'vant';

@Component({
    components: {
        Swipe,
        SwipeItem,
    },
})
export default class CmptItem extends Vue {
    @Prop({
        required: true,
        default: () => {
            return { title: null, coverUrl: null, bonus: null };
        },
    })
    private cmpt;

    @Prop({ required: false, default: false }) private isHome;
    @Prop({ required: false, default: false }) private isHomeFirst;

    get title() {
        return this.cmpt.title;
    }

    get isGZS() {
		// 港中深大赛
		return [1048,1049,1050,1051,1052,1053,1054,1055].indexOf(Number(this.cmpt.id)) > -1
	}

    get img() {
        return this.cmpt.coverUrl || this.cmpt.icon;
    }

    get rewardType1(){
        return this.cmpt.id >= 966 && this.cmpt.id <= 968 ? `HK$${this.reward.reward}` : `￥${this.reward.reward}`
    }

    // get avatar(){
    //     return this.cmpt.avatar
    // }

    get path() {
        return this.$route.path === '/';
    }

    get isOpen() {
        const date = new Date().getTime();

        return (
            this.cmpt.isOpenSignup &&
            date > new Date(this.cmpt.startTime).getTime() &&
            date < new Date(this.cmpt.endTime).getTime()
        );
    }

    get reward() {
        let rst: any = { reward: null, type: 0 };
        if (this.cmpt.bonus) {
            rst = { reward: this.toThousands(this.cmpt.bonus), type: 1 };
        } else if (this.cmpt.rewardType === 1) {
            rst = { reward: this.toThousands(this.cmpt.reward), type: 1 };
        } else {
            rst = { reward: this.cmpt.reward, type: 2 };
        }
        return rst;
    }

    get users() {
        return this.cmpt.competitors || this.cmpt.users;
    }

    get cmptId() {
        if (this.cmpt.navigationUrl) {
            const id = this.cmpt.navigationUrl.split('/competitions/').pop().split('/')[0].split('?')[0];
            return id
        } else {
            return this.cmpt.id
        }
    }

    toThousands(num) {
        var result = '',
            counter = 0;
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i != 0) {
                result = ',' + result;
            }
        }
        return result;
    }

    nav2Detail() {
        if (this.cmpt.navigationUrl) {
            const id = this.cmpt.navigationUrl.split('/competitions/').pop().split('/')[0].split('?')[0];
            this.$router.push(`/competitions/${id}`);
        } else {
            this.$router.push(`/competitions/${this.cmpt.id}`);
        }
    }
    // handleClickItem(item) {
    //         if (item.linkUrl.indexOf('datafountain.cn' > -1)) {
    //             this.$router.push(item.linkUrl.split('datafountain.cn')[1])
    //         } else {
    //             this.$router.push(item.linkUrl);
    //         }
    //     },
    mounted() {        
        // let avatars = [...this.cmpt.avatar];

        // if (avatars.length < 5) {
        //     const len = avatars.length;
        //     for (let i = 0; i < 5 - len; i++) {
        //         avatars.push({ avatar: defaultAvatar });
        //     }
        // }

        // this.cmpt.avatar = [...avatars, ...avatars];
        // this.cmpt.avatar.splice(0, 3)
    }
}
